<template>
  <el-card class="box-card">
    <div class="content-wrapper">
      <div class="picture_w">
        <el-image
          class="picture"
          :src="
            data.cover
              ? data.cover + '!283'
              : require('@/assets/images/huayuan.png')
          "
          alt=""
          lazy
        />
      </div>
      <div class="context_main">
        <div class="service_context_name">
          <span>{{ data.name }}</span>
        </div>
        <div class="service_context_deil">
          <div class="width1">
            <span>联系人：{{ data.contact }}</span>
          </div>
          <div class="width2">
            <span>联系电话：{{ data.contactPhone }}</span>
          </div>
          <div class="width2">
            <span>成立时间：{{ data.formed }}</span>
          </div>
          <div class="width3">
            <el-tooltip class="item" effect="dark" :content="data.kind" placement="bottom">
              <span>服务分类：{{ data.kind }}</span>
            </el-tooltip>
          </div>

        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {

    }
  },
  computed: {
  },
  mounted() {
    console.log('data', this.data)
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.full-container {
  width: 100%;
  height: 100vh; /* 视口高度 */
  display: flex;
  justify-content: center;
  align-items: center;
}

.box-card {
  width: 100%;
  height: 150px;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  height: 107px;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  position: relative; /* 为了竖线定位 */
}

.box-card::before {
  content: '';
  position: absolute;
  left: 16.4%;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: #E6E6E6; /* 根据需要调整颜色 */
}

.picture_w{
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中 */
  width: 157px;
  height: 107px;
}

.item {
  width: calc(50% - 1px); /* 减去竖线的宽度 */
  padding: 10px; /* 根据需要调整 */
  box-sizing: border-box;
}

.service_context_name{
  font-weight: bold;
  font-size: 23px;
  margin-top: 18px;
}

.service_context_deil{
  display: flex;
  margin-top: 35px;
  font-size: 13px;
  .width1{
    width: 140px;
    white-space: nowrap; /* 文本不换行 */
    overflow: hidden; /* 隐藏溢出部分的文本 */
    text-overflow: ellipsis; /* 显示省略号 */
  }
  .width2{
    width: 200px;
  }
  .width3{
    width: 210px;
    white-space: nowrap; /* 文本不换行 */
    overflow: hidden; /* 隐藏溢出部分的文本 */
    text-overflow: ellipsis; /* 显示省略号 */
  }
}

.context_main{
  margin-left: 50px;
}

.context_but .el-button{
  background-color: #0983CC;color: white;
  margin-left: 110px;
  margin-top: 37px;
}
</style>
